import * as React from 'react';
import { fetchApi } from '../../services/api';
import { formatNumber } from '@progress/kendo-intl';
import { Button } from '@progress/kendo-react-buttons';
import { getServiceTeamName } from 'utils/utils';

type State = {
  loading: boolean;
  dailyAssetsChart: number[];
  dailyAssetsRevenue: any[];
  error?: string;
}

type Props = {
  filter: { Name: string, Filter: string };
}

export default class DailyRevenueAssets extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      dailyAssetsChart: [],
      dailyAssetsRevenue: [],
    }

    this.refreshData = this.refreshData.bind(this);
  }

  public componentDidMount() {
    this.refreshData();
  }

  public refreshData() {
    fetchApi(`/api/Report/RevenueTodayAssets/${this.props.filter.Filter}`)
      .then((response: Array<{ ServiceTeamID: number, TotalCharges: number }>) => {
        this.setState({
          loading: false,
          dailyAssetsChart: response.map(x => x.TotalCharges),
          dailyAssetsRevenue: response,
          error: undefined,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error?.detail || 'Failed to load data'
        });
      });
  }

  public render() {
    if (this.state.loading) {
      return <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card"></div>;
    }

    if (this.state.error) {
      return (
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card text-center p-3">
          <p style={{ color: '#d32f2f', marginBottom: '10px' }}>{this.state.error}</p>
          <Button onClick={this.refreshData} fillMode='flat'>
            Retry
          </Button>
        </div>
      );
    }

    return <React.Fragment>
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card">
          <p>
            <span className="report-card-title">{this.props.filter.Name} Daily Revenue - Assets (No FSC)</span>
            <br />
            {formatNumber(this.state.dailyAssetsChart.reduce((a, b) => { return a + b }, 0), "c0")} Total Revenue
          </p>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Service Team</th>
                <th style={{ textAlign: 'right' }}>Revenue</th>
              </tr>
            </thead>
            <tbody>
              {this.state.dailyAssetsRevenue.map((revenue, index) => {
                return <tr key={index}>
                  <td>{getServiceTeamName(revenue.ServiceTeamID)}</td>
                  <td style={{ textAlign: 'right' }}>{formatNumber(revenue.TotalCharges, "c0")}</td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </React.Fragment>
  }
}
